import { createBrowserClient } from "@supabase/ssr";

const publicURL = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const createClient = () =>
  createBrowserClient(
    publicURL,
    key,
  );